site.sideContent = {
	init: function () {
		var $body = $('body');
		//$body.append('<div id="sideContent" />');

		var $sideContent = $('#sideContent');
		//$sideContent.append('<div class="wrapper" />');
		$('.wrapper', $sideContent)
			.on('click', function (e) {
				//e.stopPropagation();
			})
		;

		// Close side content on body click, outside side content area
		$body.click(function (e) {
			if ($(e.target).parents('#sideContent').length === 0 && $body.hasClass('sideContent-open')) {
				$body.removeClass('sideContent-open');
			}
		});

		// Close side content if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				if ($body.hasClass('sideContent-open')) {
					$body.removeClass('sideContent-open');
				}
			}
		});

		$('.sideContent.sideMap').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			if ($body.hasClass('sideContent-open')) {
				$body.removeClass('sideContent-open');
			} else {
				$('body').addClass('sideContent-open');
			}
		});
	}
};

site.inits.push('site.sideContent.init()');